import { createState } from 'shared'
import { navigate } from 'wouter-preact/use-browser-location'

import {
	addNewSmartContract,
	application,
	emitSystemNotification,
	userInformationState
} from 'state'
import { LocalStorageKeys } from 'types'
import { removePropertyFromStoredObject } from 'utils'

export type AcceptCollaboratorInvitationPayload = {
	userHandler: string
	publicProjectId: string
}

export type AcceptedProject = {
	name?: string
	publicId?: string
}

const isNewSmartContractModalOpenState = createState(false)
export const isNewSmartContractModalOpen =
	isNewSmartContractModalOpenState.state

export const setSmartContractModalState = (value: boolean) => {
	isNewSmartContractModalOpenState.updateState(() => value)
}

const isCollaboratorInvitationSuccessModalOpenStateContainer =
	createState(false)
export const isCollaboratorInvitationSuccessModalOpen =
	isCollaboratorInvitationSuccessModalOpenStateContainer.state

const acceptedProjectStateContainer = createState<AcceptedProject>({})
export const acceptedProjectState = acceptedProjectStateContainer.state

/*
	Actions
*/

export const handleCloseCollaboratorInvitationSuccessModal = (
	navigateToProject: boolean
) => {
	if (navigateToProject) {
		navigate(`/dapp/${acceptedProjectState.peek().publicId}`)
	}

	isCollaboratorInvitationSuccessModalOpenStateContainer.updateState(
		() => false
	)
}

export const handleAcceptCollaboratorInvitation = async (
	publicProjectId: string
) => {
	const { error, data } = await application
		.peek()
		.forManagingProjects()
		.acceptCollaboratorInvitation({
			userHandler: userInformationState.peek()!.email,
			publicProjectId
		})

	removePropertyFromStoredObject(
		LocalStorageKeys.CollaboratorInvitationProjects,
		publicProjectId
	)

	navigate(`/`, { replace: true })

	if (error) {
		emitSystemNotification({
			error,
			display: 'dialog',
			acceptText: 'Close',
			onCloseCallback: () =>
				isCollaboratorInvitationSuccessModalOpenStateContainer.updateState(
					() => false
				)
		})

		return
	}

	// Add new smart contracts to the state
	data?.smartContracts.forEach(dApp => {
		addNewSmartContract({
			...dApp!,
			projectName: data!.name,
			owner: data!.owner,
			projectId: data!.publicId,
			isCollaborator: data!.isCollaborator,
			color: data!.color!,
			isWorkspaceReady: false
		})
	})

	acceptedProjectStateContainer.updateState(() => ({
		name: data!.name,
		publicId: publicProjectId
	}))

	isCollaboratorInvitationSuccessModalOpenStateContainer.updateState(() => true)
}
